import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TablaAutomaticaComponent } from './tabla-automatica.component';
import { MatTableModule } from '@angular/material/table';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseAlertModule } from '@fuse/components/alert';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';
import { SharedModule } from 'primeng/api';
import { AdjuntoModule } from '../adjunto/adjunto.module';
import { MatSortModule } from '@angular/material/sort';



@NgModule({
  declarations: [
    TablaAutomaticaComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FuseScrollbarModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatDividerModule,
    MatDialogModule,
    MatSortModule,
    MatButtonToggleModule,
    MatCardModule,
    MatIconModule,
    FuseAlertModule,
    MatSliderModule,
    SharedModule,
    AdjuntoModule
  ],
  exports: [
    TablaAutomaticaComponent
  ]
})
export class TablaAutomaticaModule { }
